import React from "react";
import EmployeeDashboard from "@widgets/timeRegistration/EmployeeDashboard";
import {BasePage, classNames, dashboardPaddingX, dashboardPaddingY} from "peggirkit";
import {useIntl} from "react-intl";
import AuthenticationPageLogo from "@widgets/auth/AuthenticationPageLogo";
import AuthenticationPageFooter from "@widgets/auth/AuthenticationPageFooter";


const EmployeeEnvironment = () => {
    const intl = useIntl();

    return (
        <BasePage
            title={intl.formatMessage({id: "employeeLogin"})}
            appName={intl.formatMessage({id: "appName"})}
        >
            <div
                className={classNames(
                    "w-full min-h-screen flex flex-col justify-between items-center gap-24 md:gap-28",
                    dashboardPaddingX,
                    dashboardPaddingY
                )}
            >
                <div className={"h-full w-full flex flex-col items-center justify-start gap-3"}>
                    <div
                        className={classNames(
                            "w-full max-w-[480px] flex flex-col",
                            "mt-6 gap-10"
                        )}
                    >
                        <AuthenticationPageLogo titleMsgId={"employeeLogin"}/>
                        <EmployeeDashboard wrapInCard={false}/>
                    </div>
                </div>

                <AuthenticationPageFooter/>
            </div>
        </BasePage>
    );
};

export default EmployeeEnvironment;